import {
  ListGroup, Row, Col
} from "react-bootstrap";

import { IUserHistoryItem } from "interfaces/models/IUserHistoryItem";
import { format } from "date-fns";
import { enGB } from "date-fns/locale";

interface UserHistoryItemProps {
  userHistoryItem : IUserHistoryItem;
}

const UserHistoryItem = ({ userHistoryItem, ...props } : UserHistoryItemProps) => (
  <ListGroup.Item {...props}>
    <Row className="align-items-center" data-testid="userHistoryItemRow">
      <Col data-testid="userHistoryItemAction">{userHistoryItem.action}</Col>
      <Col data-testid="userHistoryItemDetails">{userHistoryItem.details}</Col>
      <Col data-testid="userHistoryItemApplication" className="d-none d-md-block">{userHistoryItem.site}</Col>
      <Col data-testid="userHistoryItemIPAddress" className="d-none d-lg-block">{userHistoryItem.ipAddress}</Col>
      <Col data-testid="userHistoryItemTimestamp">{format(new Date(userHistoryItem.timeStamp), "dd/MM/yyyy HH:mm:ss", { locale: enGB })}</Col>
    </Row>
  </ListGroup.Item>
);

export default UserHistoryItem;
